exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insurance-count-badge[data-v-c7d68b58] {\n  background-color: #085FCE;\n  color: white;\n  font-size: 14px;\n  padding: 0 4px;\n  border-radius: 22px;\n  height: 22px;\n  min-width: 22px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 500;\n}\n.insurance-count-badge span[data-v-c7d68b58] {\n  margin-top: 2px;\n}", ""]);

// exports
